module.exports = __webpack_public_path__ + "assets/img/Arty_Paris_cover.583eed3e-ps.jpg";